export default () => ({
    event_assignment_active:false
});
